<div class="store-flex-wrapper">
  <app-header></app-header>
  <app-notification></app-notification>
  <div>
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>